import React, { useContext, useEffect, useState } from 'react';
import { WModal, WTooltip } from '../../wrappers/wrapper';
import styles from './notifications.module.scss';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

import Button from 'components/atoms/button/button';
import Popover from '@mui/material/Popover';
import useDeviceType from 'custom-hooks/useDeviceType';
import NotificationsContent from '../notifications-content/notifications-content';
import ViewProfile from '../view-profile-popover/view-profile-popover';
import ProfileDialog from '../profile-dialog/profile-dialog';
import dbService from 'services/database.service';
import { UserContext } from 'contexts/userContext';

const Notifications = () => {
  const { isDesktop } = useDeviceType();
  const { user } = useContext(UserContext);
  const [userId, setUserId] = useState('');
  const [activeTab, setActiveTab] = React.useState(-1);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [showContent, setShowContent] = useState(false);
  const [unreadedCount, setUnreadedCount] = useState(0);

  useEffect(() => {
    const subscription = dbService
      .getNotificationsRealtime({
        filter: {
          receiver: user?._id,
          is_read: false,
          archived: false,
        },
      })
      .subscribe((el) => {
        setUnreadedCount(el.length);
      });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const handleOpenNotifications = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isDesktop) {
      setShowContent(true);
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleCloseNotifications = (props?: { userId?: string; profileTab?: number }) => {
    if (props?.userId) setUserId(props?.userId);
    if (props?.profileTab) setActiveTab(props?.profileTab);

    setAnchorEl(null);
    setShowContent(false);
  };

  return (
    <div className={styles.container}>
      {!!unreadedCount && <div className={styles.bage}>{unreadedCount}</div>}
      <Button type={'base'} onClick={handleOpenNotifications} className={styles.notificationButton}>
        <WTooltip title="Notifications" placement="bottom" arrow>
          <div>
            <NotificationsNoneOutlinedIcon style={{color:"var(--color-primary)"}} fontSize="small" />
            <span>Notifications</span>
          </div>
        </WTooltip>
      </Button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseNotifications}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              border: 'var(--border)',
              width: '29rem',
              height: '38rem',
              borderRadius: '0.5rem',
            },
          },
        }}
      >
        <NotificationsContent close={handleCloseNotifications} />
      </Popover>

      <WModal open={showContent} onClose={handleCloseNotifications}>
        <NotificationsContent close={handleCloseNotifications} />
      </WModal>

      {userId && (
        <ViewProfile user_id={userId} onClose={() => setUserId('')} showEditButton={false} />
      )}
      {activeTab !== -1 && (
        <ProfileDialog
          open={activeTab !== -1}
          onClose={() => setActiveTab(-1)}
          activeTab={activeTab}
          onTabChange={(tabIndex: number) => setActiveTab(tabIndex)}
        />
      )}
    </div>
  );
};

export default Notifications;
